document.addEventListener("DOMContentLoaded", function() {
  // Initialize both carousels
  initCarousel('banner-carousel-desktop');
  initCarousel('banner-carousel-mobile');
  
  function initCarousel(carouselId) {
    const carousel = document.getElementById(carouselId);
    if (!carousel) return;
    
    const slidesContainer = carousel.querySelector('.carousel-slides');
    const originalSlides = carousel.querySelectorAll('.banner-slide');
    const dots = carousel.querySelectorAll('.carousel-dot');
    const prevButton = carousel.querySelector('.carousel-prev');
    const nextButton = carousel.querySelector('.carousel-next');
    const slideCount = originalSlides.length;
    
    if (slideCount <= 0) return;
    
    // Detect RTL mode
    const isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    
    // Create clone slides for infinite scroll effect
    if (slideCount > 1) {
      // Clone first slide and append to end
      const firstClone = originalSlides[0].cloneNode(true);
      firstClone.classList.add('clone-slide');
      slidesContainer.appendChild(firstClone);
      
      // Clone last slide and prepend to beginning
      const lastClone = originalSlides[slideCount - 1].cloneNode(true);
      lastClone.classList.add('clone-slide');
      slidesContainer.insertBefore(lastClone, originalSlides[0]);
    }
    
    // Get all slides including clones
    const allSlides = carousel.querySelectorAll('.banner-slide');
    
    let currentIndex = 1; // Start at 1 because of the prepended clone
    let autoplayInterval = null;
    let isTransitioning = false;
    
    // Get autoplay settings from data attributes
    const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5000;
    const enableAutoplay = carousel.dataset.enableAutoplay === 'true';
    
    // Initialize carousel position (start at first real slide)
    updateCarousel(false);
    
    // Event listeners for controls
    prevButton.addEventListener('click', () => {
      if (isTransitioning) return;
      // In RTL mode, swap the arrow behaviors
      if (isRTL) {
        goToSlide(currentIndex + 1); // prev button goes next in RTL
      } else {
        goToSlide(currentIndex - 1);
      }
    });
    nextButton.addEventListener('click', () => {
      if (isTransitioning) return;
      // In RTL mode, swap the arrow behaviors
      if (isRTL) {
        goToSlide(currentIndex - 1); // next button goes prev in RTL
      } else {
        goToSlide(currentIndex + 1);
      }
    });
    
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        if (isTransitioning) return;
        const slideIndex = parseInt(dot.getAttribute('data-slide-index'));
        goToSlide(slideIndex + 1); // Add 1 to account for prepended clone
      });
    });
    
    // Touch swipe functionality
    let touchStartX = 0;
    let touchEndX = 0;
    
    slidesContainer.addEventListener('touchstart', e => {
      touchStartX = e.changedTouches[0].screenX;
    });
    
    slidesContainer.addEventListener('touchend', e => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });
    
    function handleSwipe() {
      if (isTransitioning) return;
      const swipeThreshold = 50;
      if (touchEndX < touchStartX - swipeThreshold) {
        // Swipe left - behavior changes in RTL
        if (isRTL) {
          goToSlide(currentIndex - 1); // In RTL, left swipe goes to previous
        } else {
          goToSlide(currentIndex + 1); // In LTR, left swipe goes to next
        }
      } else if (touchEndX > touchStartX + swipeThreshold) {
        // Swipe right - behavior changes in RTL
        if (isRTL) {
          goToSlide(currentIndex + 1); // In RTL, right swipe goes to next
        } else {
          goToSlide(currentIndex - 1); // In LTR, right swipe goes to previous
        }
      }
    }
    
    // Autoplay functionality
    function startAutoplay() {
      if (enableAutoplay && slideCount > 1) {
        autoplayInterval = setInterval(() => {
          goToSlide(currentIndex + 1);
        }, autoplaySpeed);
      }
    }
    
    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    // Pause autoplay on hover or focus
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);
    
    // Go to specific slide index
    function goToSlide(index) {
      if (isTransitioning) return;
      
      isTransitioning = true;
      currentIndex = index;
      
      updateCarousel(true);
      
      // Handle infinite scroll transitions
      setTimeout(() => {
        if (slideCount > 1) {
          // If we're at the first clone (index 0), jump to the last real slide
          if (currentIndex === 0) {
            currentIndex = slideCount;
            updateCarousel(false);
          }
          // If we're at the last clone (index slideCount + 1), jump to the first real slide
          else if (currentIndex === slideCount + 1) {
            currentIndex = 1;
            updateCarousel(false);
          }
        }
        
        isTransitioning = false;
        
        // Reset autoplay timer
        if (enableAutoplay) {
          stopAutoplay();
          startAutoplay();
        }
      }, 500); // Match the CSS transition duration
    }
    
    // Update carousel display
    function updateCarousel(withTransition = true) {
      // Enable or disable transition
      if (withTransition) {
        slidesContainer.style.transition = 'transform 0.5s ease';
      } else {
        slidesContainer.style.transition = 'none';
      }
      
      // Update slides position based on direction
      slidesContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
      
      // Calculate the real slide index for dots (accounting for clones)
      let realIndex = currentIndex - 1;
      if (slideCount > 1) {
        if (currentIndex === 0) realIndex = slideCount - 1;
        else if (currentIndex === slideCount + 1) realIndex = 0;
      } else {
        realIndex = 0;
      }
      
      // Update dots
      dots.forEach((dot, i) => {
        if (i === realIndex) {
          dot.classList.add('active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('active');
          dot.removeAttribute('aria-current');
        }
      });
      
      // Update accessibility attributes for original slides only
      originalSlides.forEach((slide, i) => {
        if (i === realIndex) {
          slide.setAttribute('aria-hidden', 'false');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }
    
    // Start autoplay if enabled
    startAutoplay();
    
    // Add keyboard navigation
    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', e => {
      if (isTransitioning) return;
      if (e.key === 'ArrowLeft') {
        // In RTL mode, left arrow should go next
        if (isRTL) {
          goToSlide(currentIndex + 1);
        } else {
          goToSlide(currentIndex - 1);
        }
      } else if (e.key === 'ArrowRight') {
        // In RTL mode, right arrow should go previous
        if (isRTL) {
          goToSlide(currentIndex - 1);
        } else {
          goToSlide(currentIndex + 1);
        }
      }
    });
    
    // Add resize handler to ensure correct layout
    window.addEventListener('resize', () => updateCarousel(false));
  }
});
